// extracted by mini-css-extract-plugin
module.exports = {"wrapper_button":"welcomeAuthActionsHeader_wrapper_button__1rc7e"};